import axiosInstance from "../../../../../shared/api/axiosInstance.js";
import { baseUrl, GET_ADVERTISMENT, GET_ALL_ADVERTISMENT_GALLERY, GET_CATEGORY, EDIT_STATE_ADVERTISMENT_DATA, DELETE_ADVERTISMENT } from "../../../../../shared/api/endpoints.js";
import { configReq } from "../../../../../shared/lib/functions.js";
/** Keeps the existing GET request and response contract. */
export function getAdvertisment(id, token) {
  return axiosInstance(`${baseUrl}/${GET_ADVERTISMENT}?id=${id}`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllAdvertismentGallery(id, token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_ADVERTISMENT_GALLERY}?Page=1&Limit=2000&filter[0][key]=advertisementId&filter[0][value]=${id}&filter[0][operator]=eq`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getCategory(data, token) {
  return axiosInstance(`${baseUrl}/${GET_CATEGORY}?id=${data?.advertisement?.galleryId}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editStateAdvertismentData(data, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_STATE_ADVERTISMENT_DATA}`, {
    ...data
  }, configReq(token));
}

/** Keeps the existing DELETE request and response contract. */
export function deleteAdvertisment(id, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_ADVERTISMENT}?id=${id}`, configReq(token));
}
